export default (options = [], {
  bodyKey = 'body',
  labelKey = 'name',
  selection = [],
} = {}) => {
  const selectedIds = selection.map(({ id }) => id);

  return options.flatMap((option) => {
    const { [bodyKey]: body, id, [labelKey]: label } = option;

    if (selectedIds.includes(id)) return [];

    return {
      ...option,
      body,
      id,
      label,
      value: option,
    };
  });
};
